// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig : {
    apiKey: "AIzaSyDb0rQKdthR-YpTuveJt5fl0BcNKzGXLYc",
    authDomain: "shah-satnam-girl-college.firebaseapp.com",
    databaseURL: "https://shah-satnam-girl-college-default-rtdb.firebaseio.com",
    projectId: "shah-satnam-girl-college",
    storageBucket: "shah-satnam-girl-college.firebasestorage.app",
    messagingSenderId: "1068643064731",
    appId: "1:1068643064731:web:6bd1dc4cfd0f0a2bc95f3e",
    measurementId: "G-3JVJSMH07Y"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
